const actions = {
  CREATE_VOUCHER: 'CREATE_VOUCHER',
  CREATE_VOUCHER_ENDED: 'CREATE_VOUCHER_ENDED',
  SEARCH_VOUCHERS: 'SEARCH_VOUCHERS',
  SEARCH_VOUCHERS_ENDED: 'SEARCH_VOUCHERS_ENDED',
  FIND_VOUCHER: 'FIND_VOUCHER',
  FIND_VOUCHER_ENDED: 'FIND_VOUCHER_ENDED',
  UPDATE_VOUCHER: 'UPDATE_VOUCHER',
  UPDATE_VOUCHER_ENDED: 'UPDATE_VOUCHER_ENDED',
  DELETE_VOUCHERS: 'DELETE_VOUCHERS',
  DELETE_VOUCHERS_ENDED: 'DELETE_VOUCHERS_ENDED',
  SEARCH_VOUCHER_ORDERS: 'SEARCH_VOUCHER_ORDERS',
  SEARCH_VOUCHER_STATUS: 'SEARCH_VOUCHER_STATUS',
  SEARCH_VOUCHERS_ORDERS_ENDED: 'SEARCH_VOUCHERS_ORDERS_ENDED',
  FIND_VOUCHER_ORDER: 'FIND_VOUCHER_ORDER',
  FIND_VOUCHER_ORDER_ENDED: 'FIND_VOUCHER_ORDER_ENDED',
  SEARCH_ISSUED_VOUCHERS: 'SEARCH_ISSUED_VOUCHERS',
  SEARCH_ISSUED_VOUCHERS_ENDED: 'SEARCH_ISSUED_VOUCHERS_ENDED',
  SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS: 'SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS_ENDED',
  SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS_ENDED: 'SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS',
  SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS: 'SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS',
  SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS_ENDED:
    'SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS_ENDED',
  FIND_ISSUED_VOUCHER_TRANSACTION_RECORD: 'FIND_ISSUED_VOUCHER_TRANSACTION_RECORD',
  FIND_ISSUED_VOUCHER_TRANSACTION_RECORD_ENDED: 'FIND_ISSUED_VOUCHER_TRANSACTION_RECORD_ENDED',
  SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS: 'SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS',
  SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS_ENDED: 'SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS_ENDED',
};

export default actions;
